module.exports = __webpack_public_path__ + "a02526c137220a132cc75f6bcdeefb13.svg";